import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  InsideLoaderCalc: {
    '&__modal-container': {
      '&__text': {
        '&--font-size': {
          fontSize: props => props.fontSize,
        },
      },
    },
  },
});

export { useStyles };
